import AsyncPage from 'pages/AsyncPage'
import AsyncHomeActivityPage from 'pages/home/activity'

import universal from 'react-universal-component'

export const UniversalLandingPage = universal<any, LandingPage>(props => import('./LandingPage'))

class AsyncLandingPage extends AsyncPage {
  constructor() {
    super({
      isChromeless: true,
      pageComponent: UniversalLandingPage,
      basicDataRequirements: {
        instance: true,
        session: false
      }
    })
  }
  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    const { session: { value: profile } = {} } = getState()
    if (profile) {
      // already logged-in, go to home/activity page instead
      // but for SSR to work properly we need to sneakily
      // run the `prepareAsyncData ahead of time` :-S
      await AsyncHomeActivityPage.prepareAsyncData(dispatch, getState, opts)
      await dispatch({
        type: 'home/activity',
        meta: {
          location: {
            kind: 'redirect'
          }
        }
      })
    }
  }
}

export default new AsyncLandingPage()
